import { formatClockText } from '../../../../../platform/util/clockSystem';
import { getCheckoutDisplay } from '../../../../../platform/util/bookingCalendarLabel';
import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { Alert, Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { PAYMENT_STATUS, CANCEL_CHECKOUT, COMPLETE_CHECKOUT } from "../../../../../platform/graphql/stripePayments";
import { formatInTimeZone } from 'date-fns-tz';
import { displayBookingDate } from '../../../../../platform/util/bookingCalendarLabel';
export default function PaymentResult() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const attemptedCancel = useRef(false);
  const attemptedCapture = useRef(false);
  const [cancelError, setCancelError] = useState("");
  const { data, loading, error, refetch, stopPolling } = useQuery(PAYMENT_STATUS, { variables: { id }, pollInterval: 3000, fetchPolicy: "network-only" });
  const [cancel] = useMutation(CANCEL_CHECKOUT);
  const [complete] = useMutation(COMPLETE_CHECKOUT);
  const payment = data?.appointmentPaymentStatus;
  const checkoutDisplay = getCheckoutDisplay(payment?.calendarSystem);
  useEffect(() => {
    if (params.get("paypal") === "1" && params.get("canceled") !== "1" && !attemptedCapture.current) {
      attemptedCapture.current = true;
      complete({ variables: { id } }).then(() => refetch()).catch(err => setCancelError(err.message));
    }
  }, [params, id, complete, refetch]);
  useEffect(() => {
    if (params.get("canceled") === "1" && !attemptedCancel.current) {
      attemptedCancel.current = true;
      cancel({ variables: { id } }).then(() => refetch()).catch(err => setCancelError(err.message));
    }
  }, [params, id, cancel, refetch]);
  useEffect(() => { if (payment && payment.status !== "pending") stopPolling(); }, [payment, stopPolling]);
  const paid = payment?.status === "paid";
  return <Box sx={{ maxWidth: 560, mx: "auto", p: 4 }}><Stack spacing={2}>
    <Typography variant="h5">{paid ? "Your booking is confirmed" : payment?.status === "expired" ? "Payment canceled or expired" : payment?.status === "refunded" ? "Payment refunded" : "Checking your payment"}</Typography>
    {(loading || payment?.status === "pending") && !error && <CircularProgress size={24} />}
    {(error || cancelError) && <Alert severity="error">{cancelError || error.message}</Alert>}
    {paid && <Alert severity="success">Payment received. A confirmation will be sent to your booking email.</Alert>}
    {payment && <Typography>{payment.title}</Typography>}
    {paid && payment?.time && <Typography>{displayBookingDate(formatInTimeZone(new Date(payment.time), payment.timezone || 'UTC', 'yyyy-MM-dd'), checkoutDisplay.calendar)} · {formatClockText(formatInTimeZone(new Date(payment.time), payment.timezone || 'UTC', 'h:mm a'), checkoutDisplay.clock)} ({payment.timezone || 'UTC'})</Typography>}
    {payment?.status === "expired" && <Typography>Your booking was not confirmed. You can choose a time and try again.</Typography>}
    {payment && payment.status !== "pending" && <Button component={Link} to={payment.bookingUrl}>Return to booking page</Button>}
    {error && <Button onClick={() => refetch()}>Check again</Button>}
  </Stack></Box>;
}
